import { useGetSettingQuery } from '../../../api/core'

export const useFeaturedGamesSetting = () => {
  return useGetSettingQuery('featured_games')
}
